import { render, staticRenderFns } from "./RoleCard.vue?vue&type=template&id=8dc6341e&scoped=true"
import script from "./RoleCard.vue?vue&type=script&lang=ts"
export * from "./RoleCard.vue?vue&type=script&lang=ts"
import style0 from "./RoleCard.vue?vue&type=style&index=0&id=8dc6341e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dc6341e",
  null
  
)

export default component.exports